import axios from 'axios';
import { storageGet, storageRemove } from './utils/safeStorage';

function normalizeApiBaseUrl(url) {
  return (url || 'http://localhost:3001').replace(/\/+$/, '');
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = storageGet('nmhelper_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isLogin = error.config?.url?.includes('/login');
    const hadToken = Boolean(storageGet('nmhelper_token'));
    const code = error.response?.data?.code;
    const errMsg = String(error.response?.data?.error || '');

    // Only force logout on real auth failures (expired / invalid / missing JWT).
    // Business errors must not use bare "Unauthorized" 401 — those stay logged in.
    const isSessionDead =
      code === 'TOKEN_EXPIRED' ||
      code === 'INVALID_TOKEN' ||
      code === 'NO_TOKEN' ||
      errMsg === 'Session expired' ||
      errMsg === 'Invalid session';

    if (status === 401 && hadToken && !isLogin && isSessionDead) {
      storageRemove('nmhelper_token');
      storageRemove('nmhelper_user');
      window.dispatchEvent(new Event('nmhelper:auth-expired'));
    }
    return Promise.reject(error);
  }
);

export default api;
